/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import _indexOfInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/index-of";import error from"../base/error";import isArray from"./isArray";import isFunction from"./isFunction";const indexOf=function(r,e,n){if(!isArray(r))throw new error.Generic("ArrayIndexOfError","Type is not an array");if(isFunction(_indexOfInstanceProperty(Array.prototype)))return _indexOfInstanceProperty(r).call(r,e,n);n||(n=0);let o=r.length;for(n<0&&(n=o+n);n<o;n++)if(r[n]===e)return n;return-1};export default indexOf;